<template>
  <form class="login" @submit.prevent="GirisYap">
    <h4>{{$t('Giris.0')}}</h4>
    <div class="form-group" :class="{ 'is-invalid': hata.email }">
      <input class="form-control" v-model="user.email" type="email">
      <label class="form-label">{{$t('Giris.4')}}</label>
      <label class="error" v-if="hata.email">{{hata.email}}</label>
    </div>
    <div class="form-group" :class="{ 'is-invalid': hata.parola }">
      <input class="form-control" v-model="user.parola"
             type="password">
      <label class="form-label">{{$t('Giris.6')}}</label>
      <label class="error" v-if="hata.parola">{{hata.parola}}</label>
    </div>
    <div class="form-group">
      <router-link :to="{ path : '/giris/parola' , query : {email:user.email}}" class="parola">Parolanızımı unuttunuz ?
      </router-link>
      <div class="clearfix"></div>
      <button type="submit" class="btn btn-mavi float-right"> {{$t('Giris.9')}}
      </button>
    </div>
    <div class="clearfix"></div>
  </form>
</template>

<script>
  export default {
    data() {
      return {
        user: {
          email: "",
          parola: ""
        },
        hata: {
          email: null,
          parola: null
        },
      }
    },

    methods: {
      GirisYap() {
        if (!this.user.email) this.hata.email = this.$t('Hata.1'); else this.hata.email = null;
        if (!this.user.parola) this.hata.parola = this.$t('Hata.2'); else this.hata.parola = null;
        if (!this.hata.email && !this.hata.parola) {
          this.$store.dispatch("Login", {...this.user, path: 'giris/giris'})
            .then(response => {
              if (response.Durum == "OK") {
                this.$message(response.Mesaj);
                window.location.reload();
                //this.$router.push("/panel");
              } else {
                if (response.Hata) this.hata = response.Hata;
                this.$message({message: response.Mesaj, type: 'error'})
              }
            })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Giris/index.vue